const menuItems = {
  items: [

    // {
    //   id: "navigation",
    //   title: "Navigation",
    //   type: "group",
    //   icon: "icon-navigation",
    //   children: [
    //     {
    //       id: "dashboard",
    //       title: "Dashboard",
    //       type: "item",
    //       icon: "feather icon-home",
    //       url: "/dashboard/",
    //     },
    //   ],
    // },

    // Banners
    {
      id: "ui-forms",
      title: "BANNERS",
      type: "group",
      icon: "icon-group",
      children: [
        {
          id: "table",
          title: "All Banners",
          type: "item",
          icon: "feather icon-server",
          url: "/banners",
        },
        {
          id: "table",
          title: "Add Banner",
          type: "item",
          icon: "feather icon-file-text",
          url: "/banner/add",
        },
      ],
    },
    // About
    {
      id: "ui-forms",
      title: "ABOUT",
      type: "group",
      icon: "icon-group",
      children: [
        // {
        //   id: "forms",
        //   title: "About Us",
        //   type: "item",
        //   icon: "feather icon-file-text",
        //   url: "/aboutUs",
        // },
        // {
        //   id: "table",
        //   title: "Director Desk",
        //   type: "item",
        //   icon: "feather icon-server",
        //   url: "/about/directorDesk",
        // },
        {
          id: "table",
          title: "Team Category",
          type: "item",
          icon: "feather icon-server",
          url: "/about/teamCategory",
        },
        {
          id: "table",
          title: "Add Team Person",
          type: "item",
          icon: "feather icon-server",
          url: "/about/addTeamPerson",
        },
        {
          id: "table",
          title: "Core Team",
          type: "item",
          icon: "feather icon-server",
          url: "/about/coreTeam",
        },
        {
          id: "table",
          title: "Team Member",
          type: "item",
          icon: "feather icon-server",
          url: "/about/teamMembers",
        },
        // {
        //   id: "table",
        //   title: "Brochure",
        //   type: "item",
        //   icon: "feather icon-server",
        //   url: "/about/brochure",
        // },
      ],
    },
    // Announcement
    {
      id: "ui-forms",
      title: "ANNOUNCEMENT",
      type: "group",
      icon: "icon-group",
      children: [
        {
          id: "table",
          title: "All Announcement",
          type: "item",
          icon: "feather icon-server",
          url: "/announcements",
        },
        {
          id: "table",
          title: "Add Announcement",
          type: "item",
          icon: "feather icon-file-text",
          url: "/announcement/add",
        },
      ],
    },
    // Projects
    {
      id: "ui-forms",
      title: "PROJECTS",
      type: "group",
      icon: "icon-group",
      children: [
        {
          id: "forms",
          title: "Add Project",
          type: "item",
          icon: "feather icon-file-text",
          url: "/projects/add",
        },
        {
          id: "table",
          title: "Project List",
          type: "item",
          icon: "feather icon-file-text",
          url: "/projects/projectList",
        },
        {
          id: "table",
          title: "Upcoming Projects",
          type: "item",
          icon: "feather icon-server",
          url: "/projects/upcomingProjects",
        },
      ],
    },
    // Training
    {
      id: "ui-forms",
      title: "TRAINING",
      type: "group",
      icon: "icon-group",
      children: [
        // {
        //   id: "forms",
        //   title: "Training Programs",
        //   type: "item",
        //   icon: "feather icon-file-text",
        //   url: "/training/trainingPrograms",
        // },
        // {
        //   id: "table",
        //   title: "Certificate Courses",
        //   type: "item",
        //   icon: "feather icon-server",
        //   url: "/training/certificateCourses",
        // },
        // {
        //   id: "table",
        //   title: "Training Compendium",
        //   type: "item",
        //   icon: "feather icon-server",
        //   url: "/training/trainingCompendium",
        // },
        {
          id: "table",
          title: "All Training",
          type: "item",
          icon: "feather icon-server",
          url: "/allTraining",
        },
        {
          id: "table",
          title: "Add Training",
          type: "item",
          icon: "feather icon-server",
          url: "/training/add",
        },
        {
          id: "table",
          title: "Training Category",
          type: "item",
          icon: "feather icon-server",
          url: "/training/category",
        },
      ],
    },
    // Research
    {
      id: "ui-forms",
      title: "RESEARCH",
      type: "group",
      icon: "icon-group",
      children: [
        {
          id: "forms",
          title: `All Research`,
          type: "item",
          icon: "feather icon-file-text",
          url: "/research",
        },
        {
          id: "forms",
          title: "Add Research",
          type: "item",
          icon: "feather icon-file-text",
          url: "/research/add",
        },
      ],
    },
    // Event
    {
      id: "ui-forms",
      title: "EVENTS",
      type: "group",
      icon: "icon-group",
      children: [
        {
          id: "forms",
          title: `All Events`,
          type: "item",
          icon: "feather icon-file-text",
          url: "/events",
        },
        {
          id: "forms",
          title: "Add Event",
          type: "item",
          icon: "feather icon-file-text",
          url: "/event/add",
        },
      ],
    },
    // Collaborations
    {
      id: "ui-forms",
      title: "COLLABORATIONS",
      type: "group",
      icon: "icon-group",
      children: [
        {
          id: "forms",
          title: "Add Collaboration",
          type: "item",
          icon: "feather icon-file-text",
          url: "/collaboration/add",
        },
        {
          id: "forms",
          title: "Collaboration List",
          type: "item",
          icon: "feather icon-file-text",
          url: "/collaboration",
        },
      ],
    },
    // Knowledge Repository
    {
      id: "ui-forms",
      title: "KNOWLEDGE REPOSITORY",
      type: "group",
      icon: "icon-group",
      children: [
        {
          id: "forms",
          title: "Add Knowledge Repository",
          type: "item",
          icon: "feather icon-file-text",
          url: "/knowledgeRepository/add",
        },
        {
          id: "forms",
          title: "Knowledge Repository",
          type: "item",
          icon: "feather icon-file-text",
          url: "/knowledgeRepository",
        },
      ],
    },
    // Contact
    {
      id: "ui-forms",
      title: "CONTACTS",
      type: "group",
      icon: "icon-group",
      children: [
        // {
        //   id: "forms",
        //   title: "Contact Us",
        //   type: "item",
        //   icon: "feather icon-file-text",
        //   url: "/contact/contactUs",
        // },
        // {
        //   id: "table",
        //   title: "Important Links",
        //   type: "item",
        //   icon: "feather icon-server",
        //   url: "/contact/importantLinks",
        // },
        {
          id: "table",
          title: "Vacancies",
          type: "item",
          icon: "feather icon-server",
          url: "/contact/vacancies",
        },
        {
          id: "table",
          title: "Add Vacancies",
          type: "item",
          icon: "feather icon-server",
          url: "/contact/vacancies/add",
        },
      ],
    },


    // users
    // {
    //   id: "ui-forms",
    //   title: "USERS",
    //   type: "group",
    //   icon: "icon-group",
    //   children: [
    //     {
    //       id: "forms",
    //       title: "Add New User",
    //       type: "item",
    //       icon: "feather icon-file-text",
    //       url: "/user/newUser",
    //     },
    //   ],
    // },

  ],
};

export default menuItems;
